import store from "./shared/config/configureStore";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/index";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import { googleClientId } from "./shared/config/config";
import App from "./app";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: ["Raleway"].join(","),
  },
});

// window.addEventListener("error", (e) => {
//   const target = e?.target as HTMLScriptElement;
//   if (
//     target?.tagName === "SCRIPT" &&
//     /chunk-\d+|\.chunk\.js/.test(target.src)
//   ) {
//     window.location.reload();
//   }
// });

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <GoogleOAuthProvider clientId={googleClientId as string}>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            limit={3}
          />
          <App />
        </GoogleOAuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  </Provider>,
  document.getElementById("root")
);
